document.addEventListener('DOMContentLoaded', () => {
  const input = document.getElementById('your-file') as HTMLInputElement | null;
  const fileNameDisplay = document.getElementById(
    'file-name'
  ) as HTMLElement | null;

  if (input && fileNameDisplay) {
    input.addEventListener('change', () => {
      const files = input.files;

      const fileName =
        files && files.length > 0 ? files[0].name : 'Aucun fichier sélectionné';

      fileNameDisplay.textContent = fileName;
    });
  }
});

document.addEventListener(
  'wpcf7submit',
  function (event) {
    // Reset du fichier sélectionné
    const fileNameDisplay = document.getElementById('file-name');
    if (fileNameDisplay) {
      fileNameDisplay.textContent =
        'Ajouter une pièce jointe (facultatif) (PDF, 30Mo max)';
    }
  },
  false
);
